import { configureStore } from "@reduxjs/toolkit";
import persistedReducer from "./rootReducers";
import storage from "redux-persist/lib/storage";

export const store = configureStore({
  reducer: persistedReducer,
});

export default store;
